module.exports = __webpack_public_path__ + "media/src/assets/fonts/Montserrat-Bold-5a6aef823dd8d1b22aacd78aebb653d6.otf";